import { b2bNl } from "./b2b";
const nl = {
  brand: {
    name: "Inner Compass",
    tagline: "Een warme, veilige plek voor je innerlijke weer.",
    subtitle: "Metgezel • Reflectie • Zorg",
  },
  common: {
    email: "E-mail",
    password: "Wachtwoord",
    name: "Naam",
    submit: "Verzenden",
    save: "Opslaan",
    saving: "Opslaan…",
    saved: "Opgeslagen",
    cancel: "Annuleren",
    confirm: "Bevestigen",
    delete: "Verwijderen",
    edit: "Bewerken",
    add: "Toevoegen",
    close: "Sluiten",
    back: "Terug",
    next: "Volgende",
    continue: "Doorgaan",
    loading: "Laden…",
    search: "Zoeken",
    filter: "Filter",
    all: "Alles",
    yes: "Ja",
    no: "Nee",
    open: "Openen",
    view: "Bekijken",
    empty: "Nog niets hier.",
    error: "Er ging iets mis.",
    retry: "Opnieuw proberen",
    optional: "optioneel",
    required: "vereist",
    signOut: "Uitloggen",
    settings: "Instellingen",
    language: "Taal",
    english: "English",
    dutch: "Nederlands",
    theme: "Thema",
    light: "Licht",
    dark: "Donker",
    system: "Systeem",
    date: "Datum",
    status: "Status",
    role: "Rol",
    actions: "Acties",
    export: "Exporteren",
    approve: "Goedkeuren",
    reject: "Afwijzen",
    revoke: "Intrekken",
    restore: "Herstellen",
    archive: "Archiveren",
    resend: "Opnieuw verzenden",
    generate: "Genereren",
    send: "Verstuur",
  },
  auth: {
    signIn: "Inloggen",
    signUp: "Account aanmaken",
    continueWithGoogle: "Doorgaan met Google",
    orContinueWith: "of ga verder met e-mail",
    welcomeBack: "Welkom terug",
    welcomeSub: "Log in om je reis voort te zetten.",
    newHere: "Nieuw bij Inner Compass?",
    haveAccount: "Al een account?",
    forgot: "Wachtwoord vergeten?",
    forgotTitle: "Wachtwoord vergeten",
    forgotSub: "Als het e-mailadres bekend is, sturen we een reset-link.",
    resetTitle: "Kies een nieuw wachtwoord",
    resetSub: "Kies een sterk wachtwoord dat je onthoudt.",
    inviteTitle: "Je bent uitgenodigd",
    inviteSub: "Vul je gegevens in om de uitnodiging te accepteren.",
    requestTitle: "Toegang aanvragen",
    requestSub: "Inner Compass is alleen op uitnodiging. Vertel ons kort over jezelf.",
    createAccount: "Maak je account aan",
    createSub: "Maak je gratis persoonlijke account. Uitnodiging van je organisatie? Voeg de code toe.",
    passwordHint: "Minimaal 10 tekens.",
    linkSent: "Als het e-mailadres bestaat is een link onderweg.",
    resetOk: "Wachtwoord opnieuw ingesteld. Je kunt nu inloggen.",
    acceptInvite: "Uitnodiging accepteren",
    inviteToken: "Uitnodigingscode",
    haveInvite: "Heb je een uitnodigingscode?",
    or: "of",
    requestAccess: "Toegang aanvragen",
    orgName: "Organisatie",
    reason: "Waarom wil je toegang?",
    submitted: "Dank je — we komen bij je terug.",
    inviteRedeemed: "Uitnodiging geaccepteerd. Welkom.",
  },
  nav: {
    home: "Start",
    companion: "Metgezel",
    checkins: "Check-ins",
    plan: "Plan",
    insights: "Inzichten",
    rhythm: "Ritme",
    victories: "Overwinningen",
    memories: "Herinneringen",
    safety: "Veiligheid",
    settings: "Instellingen",
    admin: "Beheer",
    overview: "Overzicht",
    users: "Gebruikers",
    conversations: "Gesprekken",
    flagged: "Gemarkeerd",
    invites: "Uitnodigingen",
    beta: "Bèta",
    usage: "Gebruik",
    feedback: "Feedback",
    business: "Zakelijk",
    organisation: "Organisatie",
    people: "Mensen",
    teams: "Teams",
    locations: "Locaties",
    departments: "Afdelingen",
    analytics: "Analytics",
    wellbeing: "Welzijn",
    audit: "Audit",
    care: "Zorg",
    clients: "Cliënten",
    alerts: "Meldingen",
    dossier: "Dossier",
    reports: "Rapporten",
  },
  modes: { business: "Zakelijk", care: "Zorg", modeSwitch: "Modus" },
  client: {
    greeting: "Hoe voelt je weer vandaag?",
    startCompanion: "Start een gesprek",
    quickCheckin: "Snelle check-in",
    keepGoing: "Ga door",
    todayFocus: "Focus voor vandaag",
    recentVictories: "Recente overwinningen",
    yourPlan: "Jouw plan",
    weeklyInsight: "Wekelijks inzicht",
    typeMessage: "Typ een bericht…",
    send: "Verstuur",
    slippingHelp: "Ik glijd op dit moment weg",
    craving: "Verlangen",
    startCraving: "Start een verlang-sessie",
    endCraving: "Sessie beëindigen",
    victoryToday: "Log een overwinning",
    reflection: "Avondreflectie",
    reflectionSub: "Sluit de dag af met mildheid.",
    quietReturn: "Stille terugkeer",
    yourMemories: "Je herinneringen",
    yourConsent: "Je toestemming",
    safetyTitle: "Veiligheid & steun",
    safetySub: "Je vangnet, altijd één tik verderop.",
    emergencyContact: "Noodcontact",
    helplines: "Hulplijnen",
    ifCrisis: "Als je nu steun nodig hebt",
    ifCrisisSub: "Je bent niet alleen. Reik uit — we hielden je cirkel dichtbij.",
    alertNow: "Waarschuw mijn contact nu",
    acknowledgeAlert: "Ik ben nu veilig",
    onboardingTitle: "Laten we je startklaar maken",
    onboardingSub: "Een paar zachte vragen zodat Inner Compass bij je past.",
    emotionalGoals: "Emotionele doelen",
    struggles: "Waar werk je doorheen?",
    supportPrefs: "Hoe wil je gesteund worden?",
    sleep: "Slaapschema",
    workShifts: "Werkdiensten",
    preferredName: "Voorkeursnaam",
  },
  admin: {
    title: "Beheer",
    subtitle: "Gezondheid van het gehele platform.",
    activeUsers: "Actieve gebruikers",
    conversations: "Gesprekken",
    crises: "Crisis meldingen",
    flagged: "Gemarkeerd",
    pendingApprovals: "Wachtende goedkeuringen",
    inviteCode: "Uitnodigingscode",
    codeUsage: "Gebruik",
    approveUser: "Goedkeuren",
    rejectUser: "Afwijzen",
    revokeUser: "Intrekken",
    restoreUser: "Herstellen",
    feedbackList: "Gebruikersfeedback",
    createInvite: "Uitnodiging maken",
    createBetaCode: "Bètacode maken",
    exportCsv: "CSV exporteren",
    retention: "Retentie",
    funnel: "Funnel",
    adoption: "Adoptie",
    performance: "Prestaties",
    errors: "Fouten",
    testers: "Testers",
  },
  platform: {
    title: "Zakelijk",
    subtitle: "Je organisatie in één oogopslag.",
    orgOverview: "Organisatie-overzicht",
    seats: "Plaatsen",
    used: "Gebruikt",
    available: "Beschikbaar",
    inviteMember: "Lid uitnodigen",
    createTeam: "Team aanmaken",
    createLocation: "Locatie aanmaken",
    createDepartment: "Afdeling aanmaken",
    outbox: "Verzonden",
    assignInvite: "Uitnodiging toewijzen",
    audit: "Auditlog",
    wellbeingAggregate: "Welzijn (geaggregeerd, geanonimiseerd)",
  },
  care: {
    title: "Zorg",
    subtitle: "Je cliënten, met zorg gedragen.",
    clients: "Cliënten",
    inviteClient: "Cliënt uitnodigen",
    trends: "Trends",
    generateReport: "Rapport genereren",
    weeklyReport: "Weekrapport",
    grantConsent: "Toestemming geven",
    revokeConsent: "Toestemming intrekken",
    dossier: "Dossier",
    alerts: "Crisis meldingen",
    noAlerts: "Geen actieve meldingen — cliënten zijn vandaag stabiel.",
    archiveClient: "Cliënt archiveren",
  },
  settings: {
    profile: "Profiel",
    preferences: "Voorkeuren",
    languagePref: "Voorkeurstaal",
    themePref: "Thema",
    account: "Account",
    changePassword: "Wachtwoord wijzigen",
    delete: "Account verwijderen",
    consent: "Toestemming",
  },
  errors: {
    generic: "Er ging iets mis.",
    unauthorized: "Je sessie is beëindigd. Log opnieuw in.",
    forbidden: "Je hebt geen toegang tot dit gebied.",
    notFound: "We konden dat niet vinden.",
    validation: "Controleer de velden en probeer opnieuw.",
  },
  public: {
    nav: {
      privacy: "Privacy",
      terms: "Voorwaarden",
      cookies: "Cookies",
      safety: "Veiligheid",
      support: "Hulp",
      contact: "Contact",
      deleteAccount: "Account verwijderen",
      aiSafety: "AI & veiligheid",
      privacyChoices: "Privacykeuzes",
    },
    footer: {
      legal: "Juridisch",
      help: "Hulp",
      company: "Bedrijf",
      contact: "Contact",
      rights: "Alle rechten voorbehouden.",
      companyLines: ["Inner Compass", "Nederlandse eenmanszaak", "KvK 42129904"],
    },
    lastUpdated: "Laatst bijgewerkt: 1 oktober 2026",
    privacy: {
      title: "Privacyverklaring",
      meta: "Privacyverklaring van Inner Compass — welke persoonsgegevens wij verwerken, waarom, met wie we eventueel delen, hoe lang we bewaren en jouw rechten onder de AVG.",
    },
    terms: {
      title: "Gebruiksvoorwaarden",
      meta: "Gebruiksvoorwaarden van Inner Compass — de regels voor het gebruik van onze website, mobiele en webapplicatie en overige diensten.",
    },
    cookies: {
      title: "Cookiebeleid",
      meta: "Cookiebeleid van Inner Compass — hoe onze website en webapplicatie cookies en vergelijkbare technologieën gebruiken.",
    },
    aiSafety: {
      title: "AI, welzijn en veiligheid",
      meta: "Wat Inner Compass wel en niet is: AI-grenzen, veiligheid en crisisinformatie.",
    },
    privacyChoices: {
      title: "Jouw privacykeuzes",
      meta: "Jouw privacyrechten en hoe je ze uitoefent bij het gebruik van Inner Compass.",
    },
    safety: {
      title: "Veiligheid & ondersteuning",
      subtitle: "Inner Compass is een metgezel, geen crisisdienst. Als jij of iemand die je kent in direct gevaar is, gebruik dan onderstaande hulpbronnen.",
      crisis: {
        heading: "In een crisis nu",
        body: "Bel het alarmnummer en blijf aan de lijn. Je staat er niet alleen voor.",
        eu: "Europees alarmnummer: 112",
        nl113: "Nederland — 113 Zelfmoordpreventie: bel 113 of 0800-0113 (gratis, 24/7)",
        samaritans: "Verenigd Koninkrijk — Samaritans: bel 116 123 (gratis, 24/7)",
      },
      whatwedo: {
        heading: "Wat Inner Compass rond veiligheid biedt",
        body: "De app houdt je kring van ondersteuning binnen handbereik.",
        emergency: "Voeg een noodcontact toe zodat je in een moeilijk moment een SMS kunt sturen.",
        helplines: "In de app: hulplijnenpagina met landgebonden nummers.",
        consent: "Vertrouwenspersonen en behandelaars zien alleen wat jij expliciet hebt gedeeld.",
      },
      limits: {
        heading: "Wat Inner Compass niet is",
        body: "Inner Compass is geen medisch hulpmiddel en vervangt geen professionele zorg. Bel in een noodgeval het alarmnummer.",
      },
      cta: "Contact opnemen",
    },
    support: {
      title: "Hulp & veelgestelde vragen",
      subtitle: "We zijn een klein team. Kun je hier geen antwoord vinden? Mail naar support@innercompass.tech en we reageren zo snel mogelijk.",
      contact: {
        heading: "Neem contact op",
        body: "Mail ons wanneer je wilt — meestal reageren we binnen enkele werkdagen.",
      },
      card: {
        privacy: { title: "Privacybeleid", body: "Hoe we met je gegevens omgaan, wat we verzamelen en je rechten onder de AVG." },
        terms:   { title: "Algemene voorwaarden", body: "De regels voor het gebruik van Inner Compass." },
        delete:  { title: "Je account verwijderen", body: "Verwijder je Inner Compass-account en persoonsgegevens definitief." },
        safety:  { title: "Veiligheidsinformatie", body: "Hulplijnen en informatie als jij of iemand die je kent dringend hulp nodig heeft." },
      },
    },
    contact: {
      title: "Contact met Inner Compass",
      subtitle: "Bereik ons per e-mail voor alles — ondersteuning, privacyverzoeken, feedback of samenwerkingen.",
      support: { title: "Algemene ondersteuning", body: "Bugmeldingen, productvragen, ideeën." },
      privacy: { title: "Privacy- & data-verzoeken", body: "Inzage, correctie, verwijdering of dataportabiliteit." },
      form: {
        heading: "Of stuur ons een bericht",
        subject: "Onderwerp",
        message: "Bericht",
        submit: "Open e-mail-app",
        mailto_note: "Bij verzenden opent je e-mail-app met een voorgevuld bericht. We slaan geen inzendingen op deze pagina op.",
      },
      mail: {
        name: "Naam",
        email: "E-mail",
        subjectDefault: "Bericht via Inner Compass-website",
      },
    },
    delete: {
      eyebrow: "Account verwijderen",
      title: "Account en gegevens verwijderen",
      subtitle: "Je houdt controle over je Inner Compass-account en persoonsgegevens. We controleren eerst wie je bent, zodat niemand anders je account kan verwijderen.",
      intro: "Je houdt controle over je Inner Compass-account en persoonsgegevens.",
      inApp: {
        heading: "Account verwijderen",
        body1: "Wanneer accountverwijdering in de app beschikbaar is, kun je je account verwijderen via de accountinstellingen en de weergegeven bevestigingsstappen volgen.",
        body2: "Wanneer je je account niet vanuit de app kunt verwijderen of hulp nodig hebt, kun je contact opnemen via support@innercompass.tech of privacy@innercompass.tech. Vermeld daarbij het e-mailadres dat aan je Inner Compass-account is gekoppeld.",
        verify: "We kunnen je vragen je identiteit te bevestigen om te voorkomen dat iemand anders jouw account laat verwijderen.",
      },
      removed: {
        heading: "Wat wordt verwijderd?",
        intro: "Bij definitieve accountverwijdering verwijderen of anonimiseren we, behoudens wettelijke uitzonderingen, persoonsgegevens die aan je account gekoppeld zijn, waaronder waar van toepassing:",
        items: [
          "profielgegevens;",
          "check-ins;",
          "stemmingsgeschiedenis;",
          "dagboekgegevens;",
          "reflecties;",
          "AI-gesprekken;",
          "persoonlijke herinneringen en context;",
          "herstelplannen;",
          "persoonlijke strategieën;",
          "noodcontacten;",
          "persoonlijke instellingen.",
        ],
      },
      backups: {
        heading: "Back-ups",
        body1: "Na verwijdering kunnen gegevens tijdelijk aanwezig blijven in beveiligde back-ups totdat deze volgens de normale back-upcyclus worden verwijderd of overschreven.",
        body2: "Gegevens in dergelijke back-ups worden niet opnieuw voor normale productdoeleinden gebruikt.",
      },
      legal: {
        heading: "Wettelijke verplichtingen",
        body: "Wanneer Inner Compass bepaalde beperkte informatie wettelijk moet bewaren, kan deze gedurende de vereiste periode worden behouden en uitsluitend worden gebruikt voor het betreffende wettelijke doel.",
      },
      subs: {
        heading: "Abonnementen",
        body1: "Het verwijderen van je Inner Compass-account beëindigt mogelijk niet automatisch een abonnement dat via Apple App Store, Google Play of een andere externe betalingsprovider wordt beheerd.",
        body2: "Een dergelijk abonnement moet waar nodig afzonderlijk bij de betreffende provider worden beëindigd.",
      },
      helpBlock: {
        heading: "Hulp",
        emails: ["support@innercompass.tech", "privacy@innercompass.tech"],
      },
      what: {
        heading: "Wat wordt verwijderd",
        item1: "Je account, profiel en inloggegevens.",
        item2: "Je check-ins, reflecties, plannen, herinneringen en Metgezel-gesprekken.",
        item3: "Je toestemmingsstatus en signalen die je deelde met een organisatie of behandelaar.",
        item4: "Persoonlijke identifiers in onze logs. Sommige gegevens kunnen tijdelijk als geanonimiseerde statistieken worden bewaard of voor een wettelijk minimum (bijv. facturatie) en worden daarna verwijderd.",
      },
      orgNote: {
        heading: "Als je account door een organisatie wordt gesponsord",
        body: "Het verwijderen van je persoonlijke account verwijdert het organisatie-account niet. Gegevens die aan andere mensen of aan de organisatie toebehoren (uitnodigingen die je stuurde, geaggregeerde rapporten, enz.) blijven bij hen.",
      },
      signin: {
        heading: "Bevestig je identiteit",
        body: "We verwijderen nooit een account op basis van alleen een e-mailadres. Log in met het account dat je wilt verwijderen, of mail ons via de adressen hierboven.",
        cta: "Inloggen",
        note: "Problemen met inloggen?",
      },
      confirm: {
        heading: "Verwijdering bevestigen",
        signedInAs: "Ingelogd als",
        body: "Deze actie is definitief en kan niet ongedaan worden gemaakt. Bevestig elk item hieronder.",
        ack1: "Ik begrijp dat dit mijn account en alle persoonlijke Inner Compass-data definitief verwijdert.",
        ack2: "Ik begrijp dat support dit niet kan terugdraaien.",
        typePrompt: "Typ {{word}} om te bevestigen",
        cta: "Mijn account definitief verwijderen",
      },
      confirmWord: "VERWIJDER",
      done: {
        heading: "Je account is verwijderd",
        body: "We hebben je Inner Compass-account en persoonsgegevens verwijderd. Kunnen we nog helpen? Neem contact op.",
        home: "Terug naar home",
      },
      cancelled: "Verwijdering geannuleerd.",
      help: "Hulp nodig? Mail",
      error: {
        invalid: "Die gegevens klopten niet. Probeer opnieuw.",
        tooMany: "Te veel pogingen. Probeer later opnieuw of mail ons.",
        locked: "Voor je veiligheid pauzeren we het inloggen op dit apparaat enkele minuten.",
        deleteFailed: "Het verwijderen is niet gelukt. Probeer opnieuw of mail support.",
      },
    },
  },
  download: {
    eyebrow: "Inner Compass voor Android",
    title: "Haal alles uit Inner Compass",
    body: "Inner Compass werkt het beste in de app. Neem je gesprekken, check-ins en persoonlijke inzichten overal mee naartoe.",
    android: "Download voor Android",
    continue: "Verder op de website",
    iosSoon: "iOS — binnenkort",
    scan: "Scan met je Android-telefoon om Google Play te openen.",
    scanTitle: "Scan om te downloaden",
    more: "Meer over de app",
    noAccount: "Gratis te downloaden. Geen uitnodiging of account nodig om te installeren — jij bepaalt wanneer je inlogt.",
    p1: "Je companion-gesprekken, altijd bij je.",
    p2: "Snelle dagelijkse check-ins en herinneringen.",
    p3: "Persoonlijke inzichten en ritmes door de tijd.",
    p4: "Privé by design — jouw gegevens blijven van jou.",
    nav: "App",
  },
  b2b: b2bNl,
};

export default nl;
